/** @jsxImportSource @emotion/react */

import RotatePage from 'modules/board-master/ui/pages/common/rotate-page';

import size from 'modules/board-master/domain/constants/size';
import { Team, Time } from 'modules/board-master/domain/intefaces';
import Button from 'modules/board-master/ui/components/button';
import Period from 'modules/board-master/ui/components/control-panel/period';
import Score from 'modules/board-master/ui/components/control-panel/score';
import TeamName from 'modules/board-master/ui/components/control-panel/team-name';
import Timer from 'modules/board-master/ui/components/control-panel/timer';
import { Header } from 'modules/board-master/ui/components/typography';
import { MainBlock } from './styles';

interface IProps {
  teams: [Team, Team];
  handleChangeTeamName: (name: string, index: 0 | 1) => void;
  handleChangePeriod: (period: number) => void;
  handleChangeScore: (index: 0 | 1, score: number) => void;
  handleChangeTimer: (milliseconds: number) => void;
  handleToggleTimer: () => void;
  handleToggleReverse: () => void;
  handleOpenBoard: () => void;
  time: number;
  period: number;
  timer: Time;
}

function Mobile(props: IProps) {
  const {
    time,
    timer,
    teams,
    period,
    handleOpenBoard,
    handleChangeScore,
    handleChangeTimer,
    handleToggleTimer,
    handleChangePeriod,
    handleToggleReverse,
    handleChangeTeamName,
  } = props;

  const orientation = window.screen.orientation.type.includes('portrait') ? 'portrait' : 'landscape';
  const isMobileInPortrait = orientation === 'portrait' && window.innerWidth <= size.mobile.width;
  // const isMobileInLandscape = orientation === 'landscape' && window.innerHeight < size.mobile.height && window.innerWidth < size.tablet

  if (isMobileInPortrait) {
    return <RotatePage />;
  }

  return (
    <MainBlock>
      <div id="upper-block" className="flex-center mt-auto flex flex-col">
        <Header>тайм</Header>
        <div className="flex flex-row gap-6">
          <TeamName
            id="team-name"
            index={0}
            name={teams[0].name}
            setName={(name: string) => {
              handleChangeTeamName(name, 0);
            }}
          />
          <Period disabled={timer.isActive} id="period" value={period} setValue={handleChangePeriod} />
          <TeamName
            id="team-name"
            index={1}
            name={teams[1].name}
            setName={(name: string) => {
              handleChangeTeamName(name, 1);
            }}
          />
        </div>
      </div>
      <div className="mb-auto flex flex-row gap-7" style={{ marginTop: 10 }}>
        <Score id="score" setValue={(value) => handleChangeScore(0, value)} value={teams[0].score} />
        <Timer
          id="timer"
          milliseconds={time}
          setValue={handleChangeTimer}
          isReverse={timer.isReverse}
          isTimerStart={timer.isActive}
          handlerToggleReverse={handleToggleReverse}
          handlerToggleTimer={handleToggleTimer}
        />
        <Score id="score" setValue={(value) => handleChangeScore(1, value)} value={teams[1].score} />
      </div>

      <Button id="open-board-button" onClick={handleOpenBoard} variant="blue" shape="circle">
        Посмотреть табло
      </Button>
    </MainBlock>
  );
}

export default Mobile;
